import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PageDiv = styled.div`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 19.7029px;
  line-height: 25px;
  text-align: center;
  color: ${({ active }) => (active ? '#42464C' : '#a9aeb4')};
  margin-left: 0.8rem;
  cursor: pointer;
  user-select: none;
`;
